import React from 'react';
import c from '../w.js';

const IconPlus = React.memo(
  c(
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11 13V20H13V13H20V11H13V4H11V11H4V13H11Z"
      }
    )
  )
);

export { IconPlus };
